import React from 'react';
import { Box, Heading, Link } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface AuthSuccessMessageProps {
  message: string;
  onBackToLoginClick: () => void;
}

const AuthSuccessMessage: React.FC<AuthSuccessMessageProps> = ({
  message,
  onBackToLoginClick,
}) => {
  const { t } = useTranslation();

  return (
    <Box textAlign="center" className="login-form">
      <Heading
        as="h1"
        mb={{ base: '14px', md: '34px' }}
        textAlign="center"
        fontSize={{ base: 'sm', md: 'xl' }}
        fontWeight={500}
        ml="auto"
        mr="auto"
        maxWidth="305px"
      >
        {message}
      </Heading>

      <Link
        fontSize={{ base: 'xs', md: 'md' }}
        fontWeight={400}
        textDecoration={'underline'}
        color="alea.500"
        onClick={onBackToLoginClick}
      >
        {t('login_Button')}
      </Link>
    </Box>
  );
};

export default AuthSuccessMessage;
